const compactFormatterNumber = new Intl.NumberFormat('en', { notation: 'compact' });

export default compactFormatterNumber;
